// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const CLAUSULAS_COM_APLIC = {
  OC: 'CLAUSULAS_COM_APLIC1',
  PO: 'CLAUSULAS_COM_APLIC2',
  PV: 'CLAUSULAS_COM_APLIC3',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    CLAUSULAS_COM_APLIC1: 1,
    CLAUSULAS_COM_APLIC2: 2,
    CLAUSULAS_COM_APLIC3: 3
  }
}
